// plop_marker:layouts_import
import PositionsCareers from "./positions-careers/index.js";
import SearchBarCareers from "./search-bar-careers/index.js";
export default {
    // plop_marker:layouts_add_layout
    PositionsCareers,
    SearchBarCareers
};
